import { Box } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

export const StaticDivider: FunctionComponent = () => (
  <Box width={1} borderTopWidth={1}>
    &nbsp;
  </Box>
)
